// eslint-disable-next-line no-shadow
export enum UserStatus {
  activated = 1
}
